import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

// API
import * as VenueApi from "../../api/apis/VenueApi";
import * as ActivitySessionApi from "../../api/apis/ActivitySessionApi";
import * as DiscountApi from "../../api/apis/DiscountApi";
import * as TransactionApi from "../../api/apis/TransactionApi";
import * as ActivityApi from "../../api/apis/ActivityApi";
import * as TransactionPostDto from "../../api/models/TransactionPostDto";
import * as TransactionDto from "../../api/models/TransactionDto";
import { VenueDto } from "../../api/models/VenueDto";
import { ActivitySessionListDto } from "../../api/models/ActivitySessionListDto";
import { DiscountListDto } from "../../api/models/DiscountListDto";
import { CustomFieldDto } from "../../api/models/CustomFieldDto";
import { ActivitySessionDateLookupDto } from "../../api/models/ActivitySessionDateLookupDto";

// Components
import VenueDetailComponent from "../../components/Venues/VenueDetail/VenueDetail";

import * as Utils from "../../utils";
import { Alert } from "../../models/alert";

interface RouteParams {
  venueid: string;
  channelid: string;
}

const VenuDetailLayout: React.FC<any> = (props: any) => {
  const [venue, setVenue] = useState<VenueDto>({});
  const [sessions, setSessions] = useState<ActivitySessionListDto[]>([]);
  const [discounts, setDiscounts] = useState<DiscountListDto[]>([]);
  const [customFields, setCustomFields] = useState<CustomFieldDto[]>([]);
  const [dates, setDates] = useState<ActivitySessionDateLookupDto[]>([]);
  const [time, setTime] = useState<number>(Date.now());
  const [modalAlert, setModalAlert] = useState<Alert>();
  let params = useParams<RouteParams>();
  let history = useHistory();

  // Defines wether the "Reservar" button has to be disabled or not.
  const [submittingForm, setSubmittingForm] = useState<boolean>(false);

  // Refresh page
  useEffect(() => {
    let interval = setInterval(
      () => setTime(Date.now()),
      Utils.RefreshInterval
    );

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Get Venue
  useEffect(() => {
    let venueid : string = params.venueid;
    let channelid : string = params.channelid;

    Promise.all([
      new VenueApi.VenueApi().channelsChannelIdVenuesVenueIdGet({
        venueId: venueid,
        channelId: channelid,
      })
    ])
    .then((responses: any) => {
      setVenue((venue: VenueDto) => venue = responses[0].item);

      if (responses[0].item.chooseDateFirst) {
        // Get dates by by venue id
        new ActivitySessionApi.ActivitySessionApi()
          .getSessionDatesByVenue({venueId: responses[0].item.oid})
          .then((response: any) => {
            setDates((dates: ActivitySessionDateLookupDto[]) => dates = response.data)
          })
          .catch((response: any) => {
            Utils.showError(props.setAlert, response)
          })
      } else {
        getSessions(responses[0].item.oid, undefined);
      }
    })
    .catch((response: any) => {
      Utils.showError(props.setAlert, response);
    });
  }, [time]);

  // Get sessions by venue id
  const getSessions = (venueId: string, date: string|undefined) => {
    new ActivitySessionApi.ActivitySessionApi().getSessionsByVenue({
      venueId: venueId,
      date: date
    })
    .then((response: any) => {
      setSessions((sessions: ActivitySessionListDto[]) => sessions = response.data);
    })
    .catch((response: any) => {
      Utils.showError(props.setAlert, response)
    })
  };

  // Get discounts by session id
  const getDiscounts = (sessionId: string) => {
    new DiscountApi.DiscountApi()
      .getDiscounts({ sessionId: sessionId })
      .then((response: any) => {
        setDiscounts((discount: DiscountListDto[]) => discount = response.data);
      })
      .catch((response: any) => {
        Utils.showError(props.setAlert, response);
      });
  };

  // Get custom fields by activity id
  const getCustomFields = (activityId: any) => {
    new ActivityApi.ActivityApi()
      .getCustomFields({activityId: activityId})
      .then((response: any) => {
        setCustomFields((customFields: CustomFieldDto[]) => customFields = response.data)
      })
      .catch((response: any) => {
        Utils.showError(props.setAlert, response)
      })
  };
    
  // Post transaction
  const postTransaction = (
    values: TransactionPostDto.TransactionPostDto,
    sessionId: string
    ) => {
      new TransactionApi.TransactionApi()
        .postTransaction({ sessionId: sessionId, transactionPostDto: values })
        .then((response: any) => {
          if (response.errors && response.errors.length > 0) {
            Utils.showNotification(setModalAlert, response);
          } else {
            history.push(params.venueid + "/confirmBooking");
            props.setAcceptedTransaction((transaction: TransactionDto.TransactionDto) => transaction = response.item);
          }
          setSubmittingForm(false);
    })
    .catch((response: any) => {
      Utils.showModalError(setModalAlert, response);
    });
  };

  return venue != null ? (
    <div>
      <VenueDetailComponent
        {...props}
        venue={venue}
        dates={dates}
        sessions={sessions}
        discounts={discounts}
        customFields={customFields}
        submittingForm={submittingForm}
        setSubmittingForm={setSubmittingForm}
        modalAlert={modalAlert}
        setModalAlert={setModalAlert}
        getSessions={getSessions}
        getDiscounts={getDiscounts}
        getCustomFields={getCustomFields}
        postTransaction={postTransaction}
      />
    </div>
  ) : (
    <div></div>
  );
};

export default VenuDetailLayout;
